export const PER_PAGE_OPTIONS = [10, 20, 50, 100];
